import { render } from "./UploaderBtn.vue?vue&type=template&id=48715187"
import script from "./UploaderBtn.vue?vue&type=script&lang=js"
export * from "./UploaderBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QUploaderAddTrigger from 'quasar/src/components/uploader/QUploaderAddTrigger.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QUploaderAddTrigger});
